import { Modal, Button } from 'react-bootstrap'

export default function ConfirmDialog(props) {
  return (
    <Modal show={props.show} onHide={props.onClose} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onClose}>
          No
        </Button>
        <Button variant="primary" onClick={props.onConfirm}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}    
